import React from 'react';
import { useDispatch } from 'react-redux';
import { Button, DialogActions, DialogContent, DialogTitle } from '@mui/material';

import { closeDialog, openDialog } from 'app/store/fuse/dialogSlice';
import { Form, ModuleSearchField, useSettings, Utils } from 'app/main/components';

interface GroupsUsersAddDialogProps {
	model: any;
	updateRefresh: () => void;
}

export const showGroupsUsersAddDialog = (props: GroupsUsersAddDialogProps) =>
	openDialog({
		children: <GroupsUsersAddDialog {...props} />,
		maxWidth: 'xs',
		fullWidth: true
	});

export function GroupsUsersAddDialog({ model, updateRefresh }: GroupsUsersAddDialogProps) {
	const dispatch = useDispatch();
	const { t } = useSettings();

	const [userUid, setUserUid] = React.useState<string | null>(null);

	function addUser() {
		Utils.executeStored({
			action: `st_groups_users_add`,
			dispatch,
			data: {
				grus_user_uid: userUid,
				grus_grps_uid: model.grps_uid
			},
			successHandler: response => {
				if (response.data.message === 'USER_ALREADY_IN_GROUP_ERROR')
					dispatch(Utils.alertMsg(t('USER_ALREADY_IN_GROUP_ERROR'), 'error'));
				else {
					dispatch(Utils.alertSuccessMsg(t));
					dispatch(closeDialog());
					if (updateRefresh) updateRefresh();
				}
			}
		});
	}

	return (
		<>
			<DialogTitle>{t('DIALOG_GROUP_ADD_USER_TITLE')}</DialogTitle>
			<DialogContent>
				<Form id="groupsUsersAddDialog" onSubmit={addUser}>
					<ModuleSearchField
						name="new_member"
						label={t('DETAILS_GROUPS_FIELD_USER')}
						module="users"
						uid={userUid}
						isEdit
						sendChange={(_, newValue) => setUserUid(newValue)}
					/>
				</Form>
			</DialogContent>
			<DialogActions>
				<Button onClick={() => dispatch(closeDialog())}>{t('DIALOG_ACTION_CANCEL')}</Button>
				<Button type="submit" form="groupsUsersAddDialog" color="secondary">
					{t('DIALOG_ACTION_ADD')}
				</Button>
			</DialogActions>
		</>
	);
}
